export default "/images/Vector.png?f476fa8dc335622248ce5cc5bf2ce8ff";